function injectStyle (ssrContext) {
  require("!!../../../../extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-427e4852\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../vue-loader/lib/selector?type=styles&index=0!./HalfCircleSpinner.vue")
}
var Component = require("!../../../../vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../vue-loader/lib/selector?type=script&index=0!./HalfCircleSpinner.vue"),
  /* template */
  require("!!../../../../vue-loader/lib/template-compiler/index?{\"id\":\"data-v-427e4852\",\"hasScoped\":true,\"transformToRequire\":{\"video\":\"src\",\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"}}!../../../../vue-loader/lib/selector?type=template&index=0!./HalfCircleSpinner.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-427e4852",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./~/epic-spinners/src/components/lib/HalfCircleSpinner.vue
// module id = 234
// module chunks = 1